/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import moment from "moment-timezone";

import { DataTableList } from '../../../components/DataTable/DataTableList';
import TopBar from '../../../components/TopBar';
import DeleteConfirmationPopup from '../../../components/DeleteConfirmationPopup';
import AddBrand from '../../../components/Products/Brand/AddBrand';

import Delete from "../../../assets/images/delete.svg";
import penIcon from "../../../assets/images/pen-img.svg";
import placeholder from '../../../assets/images/default/malmart-placeholder-300x300.png'
import searchIcon from "../../../assets/images/icon-search.svg";

import styles from '../page.module.css'
import UploadMediaPopup from '../../../components/UploadMediaPopup';
import { createProductBrand, deleteProductBrands, getProductBrands, updateProductBrand } from '../../../api/productBrandsApi';

const AllBrand = () => {

    const popupRef = useRef()
    const addPopupRef = useRef()

    const [brandList, setBrandList] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [columnWidths, setColumnWidths] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toggleSelect, setToggleSelect] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);  // single row or "multiple"
    const [error, setError] = useState('');
    const [showUploadMediaPopup, setShowUploadMediaPopup] = useState(false);
    const [uploadMediaPopupFor, setUploadMediaPopupFor] = useState('');
    const [uploadMediaPopupTab, setUploadMediaPopupTab] = useState('upload');
    const [selectedFeatureImage, setSelectedFeatureImage] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [editBrandId, setEditBrandId] = useState(null);
    const [isSlugChanged, setIsSlugChanged] = useState(false);


    // Add brand popup states
    const [showAddBrandPopup, setShowAddBrandPopup] = useState(false);
    const [formData, setFormData] = useState({
        brandId: null,
        image: '',
        name: '',
        slug: '',
        seoContent: '',
        seoTitle: '',
        keyword: '',
        isPopular: false
    });
    const [errorMessage, setErrorMessage] = useState({});
    // Search states
    const [searchTerm, setSearchTerm] = useState('');
    const [searchInput, setSearchInput] = useState('');

    const fetchBrands = async () => {
        setIsLoadingData(true);
        setError('');
        try {
            const response = await getProductBrands({
                page: currentPage,
                perPage: 10,
                search: searchTerm,
                orderBy: 'date'
            });

            const brandData = response?.data || []
            if (response?.data?.result?.length <= 0) {
                setIsLoadingData(false);
            }
            setBrandList(brandData?.result || [])
            setTotalPage(brandData?.totalPages)
        } catch (err) {
            setError('Failed to fetch brands. Please try again.');
            console.log('Error fetching brands:', err);
            setIsLoadingData(false)
        }
    };

    useEffect(() => {
        fetchBrands();
    }, [currentPage, searchTerm]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
            if (addPopupRef.current && !addPopupRef.current.contains(event.target) && !showUploadMediaPopup) {
                setShowAddBrandPopup(false);
            }
        };

        // Attach the event listener when the component mounts
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showUploadMediaPopup]);

    useEffect(() => {
        if (selectedFeatureImage) {
            setFormData({
                ...formData,
                image: selectedFeatureImage[0]
            });
        }
    }, [selectedFeatureImage]);

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = brandList?.reduce((acc, row) => {
                Object.keys(row).forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = Math.max(dataValue?.length, title?.length);

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});

            if (tempWidths !== undefined) {
                const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});
                setColumnWidths(widthMap);
            }
            resolve();
        });
    };

    useEffect(() => {
        if (brandList?.length > 0) {
            calculateColumnWidths();
        }
    }, [brandList]);

    useEffect(() => {
        if (Object.keys(columnWidths).length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);
        }
    }, [columnWidths]);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(brandList?.map((row) => row?._id));
        }
        setIsAllSelected(!isAllSelected);
    };

    const columns = [
        {
            name: 'Image',
            cell: (row) => <div><img src={row?.image?.url ?? placeholder} alt={row?.image?.name ?? row.name} style={{ width: '50px', height: '50px', objectFit: 'cover' }} /></div>,
            width: '80px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" },
        },
        {
            name: 'Name',
            selector: (row) => row?.name,
            cell: (row) => <div className='editTitle'>{row.name}</div>,
            sortable: true,
            minWidth: columnWidths['name'] ? `${parseInt(columnWidths['name']) + 50}px` : '200px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Created Date',
            selector: (row) => row?.createdDate,
            cell: (row) => <div>{moment(row.createdDate).format('MMM DD, YYYY')}</div>,
            sortable: true,
            width: '150px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="action-buttons">
                    <button className="edit-btn" onClick={() => {
                        setIsEditMode(true);
                        setEditBrandId(row.brandId);
                        setFormData({
                            brandId: row.brandId,
                            image: row.image || '',
                            name: row.name,
                            slug: row.slug,
                            seoContent: row.seoContent || '',
                            seoTitle: row.seoTitle || '',
                            keyword: row.keyword || '',
                            isPopular: row?.isPopular || false
                        });
                        setShowAddBrandPopup(true);
                    }}><img src={penIcon} alt="pen-icon" /></button>
                    <button className="delete-btn" onClick={() => {
                        setDeleteTarget({ type: "single", row });
                        setShowDeletePopup(true);
                    }}><img src={Delete} alt="delete-icon" /></button>
                </div>
            ),
            width: "90px"
        }
    ];

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const confirmDelete = async () => {
        if (!deleteTarget) return;
        setIsLoading(true);

        try {
            
            let brandsIds = [];
    
            if (deleteTarget.type === "single") {
                const id = deleteTarget.row.brandId;
                brandsIds.push(id);
    
                setBrandList(prev =>
                    prev.filter(item => item.brandId !== id)
                );
            }
    
            if (deleteTarget.type === "multiple") {
                brandsIds = [...deleteTarget.rows]; // rows already contains ids
                setBrandList(prev =>
                    prev.filter(item => !deleteTarget.rows.includes(item.brandId))
                );
                setSelectedRows([]);
                setIsAllSelected(false);
                setToggleSelect(prev => !prev);
            }
    
            await deleteProductBrands(brandsIds);
            setIsLoading(false)
    
            setShowDeletePopup(false);
            setDeleteTarget(null);
        } catch (error) {
            console.log(error);
            setIsLoading(false)
        }

    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errorMessage[name]) {
            setErrorMessage(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleImageUpload = (e) => {
        // const file = e.target.files[0];
        // if (!file) return;

        // const reader = new FileReader();
        // reader.onload = () => {
        //     handleChange({
        //         target: { name: "image", value: reader.result }
        //     });
        // };

        // reader.readAsDataURL(file);
        e.stopPropagation();
        setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media');
    };

    const handleSubmit = async () => {
        const errors = {};

        if (!formData?.name?.trim()) errors.name = "Brand name is required";
        if (!formData?.slug?.trim()) errors.slug = "Slug is required";

        if (Object.keys(errors).length) {
            setErrorMessage(errors);
            return;
        }

        setIsLoading(true);

        try {
            if (isEditMode) {

                const editBrandData = {
                    name: formData.name,
                    slug: formData.slug,
                    seoContent: formData?.seoContent || "",
                    seoTitle: formData?.seoTitle || "",
                    keyword: formData?.keyword || "",
                    image: formData?.image?.id || "",
                    isPopular: formData?.isPopular || false
                };

                const editBrandRes = await updateProductBrand(editBrandId, editBrandData);
                const editedBrandData = editBrandRes?.data || [];

                // ✅ EDIT BRAND
                setBrandList(prev =>
                    prev.map(item =>
                        item.brandId === editBrandId
                            ? {
                                ...item,
                                ...editedBrandData
                            }
                            : item
                    )
                );
            } else {
                // ✅ ADD BRAND
                const newBrandData = {
                    name: formData.name,
                    slug: formData.slug,
                    seoContent: formData?.seoContent || "",
                    seoTitle: formData?.seoTitle || "",
                    keyword: formData?.keyword || "",
                    image: formData?.image?.id || "",                    
                    isPopular: formData?.isPopular || false
                };

                const createBrandRes = await createProductBrand(newBrandData);
                const createdBrandData = createBrandRes?.data || [];

                setBrandList(prev => [createdBrandData, ...prev]);
            }

            // reset
            setShowAddBrandPopup(false);
            setFormData({
                brandId: null,
                image: '',
                name: '',
                slug: '',
                seoContent: '',
                seoTitle: '',
                keyword: '',
            });
            setSelectedFeatureImage('');
            setIsEditMode(false);
            setEditBrandId(null);
            setErrorMessage({});
        } catch (err) {
            console.log({ err })
            setError("Something went wrong");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <div className={`brand-list ${styles.productList} ${brandList?.length <= 10 && `${styles.productListHeight}`}`}>
                <TopBar />
                <div className={`${styles.productDatatableList}`}>
                    <div className={`${styles.productHeader}`}>
                        <div className={`${styles.leftSide}`}>
                            <div className={`${styles.searchBar}`}>
                                <img src={searchIcon} alt="Search" />
                                <input
                                    type="text"
                                    placeholder="Search brands..."
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && setSearchTerm(searchInput)}
                                />
                            </div>
                            <button className={`${styles.addBtn}`} onClick={() => setSearchTerm(searchInput)}>Search</button>
                        </div>
                        <div className={`${styles.actionButtonsDeleteAdd}`}>
                            <button className={`${styles.addBtn}`} onClick={() => {
                                setIsEditMode(false);
                                setEditBrandId(null);
                                setFormData({
                                    brandId: null,
                                    image: '',
                                    name: '',
                                    slug: '',
                                    seoContent: '',
                                    seoTitle: '',
                                    keyword: '',
                                });
                                setErrorMessage({});
                                setShowAddBrandPopup(true);
                                setIsSlugChanged(false)
                            }}>Add Brand</button>
                            {selectedRows?.length > 0 && (
                                <div className={`${styles.deleteSelectedBtn}`} onClick={() => {
                                    setDeleteTarget({ type: "multiple", rows: selectedRows });
                                    setShowDeletePopup(true);
                                }}>
                                    <img src={Delete} alt="delete-icon" />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className={`brandTable dataTable-list ${brandList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
                        <DataTableList
                            columns={columns}
                            data={brandList.filter(brand =>
                                searchTerm.trim() === '' ||
                                brand.name.toLowerCase().includes(searchTerm?.toLowerCase())
                            )}
                            onSelectedRowsChange={({ selectedRows }) => {
                                const selectedIds = selectedRows.map((row) => row.brandId);
                                setSelectedRows(selectedIds);
                                setIsAllSelected(selectedIds.length === brandList.length);
                            }}
                            progressPending={isLoadingData}
                            currentPage={currentPage}
                            onChangePage={setCurrentPage}
                            paginationTotalRows={totalPage}
                            selectableRows
                            selectAllRows={isAllSelected}
                            clearSelectedRows={toggleSelect}
                            onSelectAllChange={handleMasterCheckboxChange}
                            customStyles={customStyles}
                            selectableRowsComponent="input"
                            progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                        />
                    </div>
                </div>
                <DeleteConfirmationPopup
                    showDeletePopup={showDeletePopup}
                    setShowDeletePopup={setShowDeletePopup}
                    reference={popupRef}
                    title={deleteTarget?.type === "single" ? 'brand' : selectedRows?.length === 1 ? 'brand' : `brands`}
                    description={deleteTarget?.type === "single" ? `Are you sure you want to delete ${deleteTarget?.row?.name}?` : selectedRows?.length === 1 ? `Are you sure you want to delete brand?` : `Are you sure you want to delete ${selectedRows?.length} brands?`}
                    confirmDelete={confirmDelete}
                    isLoading={isLoading}
                />
                <AddBrand
                    showAddBrandPopup={showAddBrandPopup}
                    popupRef={addPopupRef}
                    errorMessage={errorMessage}
                    formData={formData}
                    setFormData={setFormData}
                    handleChange={handleChange}
                    setShowAddBrandPopup={setShowAddBrandPopup}
                    handleSubmit={handleSubmit}
                    handleImageUpload={handleImageUpload}
                    isLoading={isLoading}
                    error={error}
                    isSlugChanged={isSlugChanged}
                    setIsSlugChanged={setIsSlugChanged}

                />
            </div>
            {showUploadMediaPopup &&
                <UploadMediaPopup showUploadMediaPopup={showUploadMediaPopup} setShowUploadMediaPopup={setShowUploadMediaPopup} setSelectedProfileImage={setSelectedFeatureImage} uploadMediaPopupFor={uploadMediaPopupFor} uploadMediaPopupTab={uploadMediaPopupTab} />
            }
        </>
    )
}

export default AllBrand
